export enum FilterValidationMessages {
	INCOMPLETE_RULES = 'reportFilters.incompleteRules',
	DATE_RANGE_LIMIT = 'reportFilters.dateRangeLimitExceeded',
	DATE_RANGE_NEGATIVE = 'reportFilters.dateRangeNegative2',
	VALID = ''
}


